import { Environment } from '../types/MainContextType';

interface ApiEndpoints {
  idwalApi: string;
  orchestrationApi: string;
  circuitBreakerApi: string;
  circuitBreakerFunctionApi: string;
  shadowPulseApi: string;
}

/**
 * Returns the API endpoints for the specified environment
 * @param environment The current environment (development, staging, production)
 * @returns Object containing the API endpoints for the specified environment
 */
export const getApiEndpoints = (environment: Environment): ApiEndpoints => {
  switch (environment) {
    case 'development':
      return {
        idwalApi: process.env.REACT_APP_DEV_IDWAL_API_URL || '',
        orchestrationApi: process.env.REACT_APP_DEV_ORCH_API_URL || '',
        circuitBreakerApi: process.env.REACT_APP_CIRCUIT_BREAKER_API || '',
        circuitBreakerFunctionApi: process.env.REACT_APP_CIRCUIT_BREAKER_FUNCTION_API || '',
        shadowPulseApi: process.env.REACT_APP_SHADOWPULSE_API_URL || '',
      };
    case 'staging':
      return {
        idwalApi: process.env.REACT_APP_STAGING_IDWAL_API_URL || '',
        orchestrationApi: process.env.REACT_APP_STAGING_ORCH_API_URL || '',
        circuitBreakerApi: process.env.REACT_APP_CIRCUIT_BREAKER_API || '',
        circuitBreakerFunctionApi: process.env.REACT_APP_CIRCUIT_BREAKER_FUNCTION_API || '',
        shadowPulseApi: process.env.REACT_APP_SHADOWPULSE_API_URL || '',
      };
    case 'production':
      return {
        idwalApi: process.env.REACT_APP_PROD_IDWAL_API_URL || '',
        orchestrationApi: process.env.REACT_APP_PROD_ORCH_API_URL || '',
        circuitBreakerApi: process.env.REACT_APP_CIRCUIT_BREAKER_API || '',
        circuitBreakerFunctionApi: process.env.REACT_APP_CIRCUIT_BREAKER_FUNCTION_API || '',
        shadowPulseApi: process.env.REACT_APP_SHADOWPULSE_API_URL || '',
      };
    default:
      // Default to development if environment is not recognized
      return {
        idwalApi: process.env.REACT_APP_DEV_IDWAL_API_URL || '',
        orchestrationApi: process.env.REACT_APP_DEV_ORCH_API_URL || '',
        circuitBreakerApi: process.env.REACT_APP_CIRCUIT_BREAKER_API || '',
        circuitBreakerFunctionApi: process.env.REACT_APP_CIRCUIT_BREAKER_FUNCTION_API || '',
        shadowPulseApi: process.env.REACT_APP_SHADOWPULSE_API_URL || '',
      };
  }
};
